import type {ReactNode} from 'react'

import {RepoIssuesSidebar} from './RepoIssuesSidebar'

/**
 * Shared `renderSidebar` callback for `RepoIssuesPageLayout` and
 * `useRepoIssuesSidebarPanes`. Renders the issues sidebar with the
 * app-specific context (preload, params, payload).
 */
export function renderIssuesSidebar(collapsible?: boolean): ReactNode {
  return <RepoIssuesSidebar collapsible={collapsible} />
}
